<template>
  <div>
    <p class="text-center my-1">lat: {{ lat }} lng: {{ lng }}</p>
    <div>
      <video playsinline id="video-stream" width="100%" height="100%" autoplay></video>
      <!-- Take photo -->
      <v-fab-transition>
        <v-btn
          class="btn_float v-btn--example"
          color="info"
          fab
          large
          dark
          bottom
          @click.stop="takePhoto"
        >
          <v-icon>mdi-camera</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>

    <canvas
      ref="canvas"
      :width="width"
      :height="height"
      style="display: none"
    ></canvas>
    <!-- Capture Dialog -->
    <v-dialog v-model="dialog" max-width="300">
      <v-card>
        <v-card-title class="headline"> Imagen capturada </v-card-title>

        <v-img :src="capture" style="max-height: 60%;"></v-img>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="dialog = false">
            <v-icon>mdi-sync</v-icon>
            Repetir
          </v-btn>

          <v-btn color="green darken-1" text @click="setCaptures">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      videoElement: null,
      capture: null,
      cameraSelected: null,
      currentStream: null,
      width: 0,
      height: 0,
      lat: 0,
      lng: 0,
    };
  },
  created() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
    this.getCoordinates();
    this.startStream();
  },
  beforeDestroy() {
    this.stopStream();
  },
  computed: {
    ...mapState("logs", ["captureCount","log_edit"]),
  },
  methods: {
    ...mapMutations("logs", [
      "SET_LOGBOOK_CAPTURE_COUNT",
      "ADD_TO_EVIDENCES",
      "SET_LOGBOOK_VIEW",
    ]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    // Start stream video (Show it on the screen)
    async startStream() {
      let constraints = {
        video: {},
      };
      if (!this.cameraSelected) {
        constraints.video.facingMode = "environment";
      } else {
        constraints.video.deviceId = { exact: this.cameraSelected };
      }
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement = document.getElementById("video-stream");
      this.videoElement.srcObject = stream;
      this.currentStream = stream;

      this.videoElement.addEventListener(
        "loadedmetadata",
        (e) => {
          (this.width = this.videoElement.videoWidth),
            (this.height = this.videoElement.videoHeight);
        },
        false
      );

     
    },
    getCoordinates() {
      if (navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.lat = position.coords.latitude.toFixed(3);
          this.lng = position.coords.longitude.toFixed(3);
        });
      }
    },
    // Stop stream
    stopStream() {
      const tracks = this.currentStream.getTracks();
      tracks.forEach(function(track) {
        track.stop();
      });
      this.videoElement.srcObject = null;
    },
    // Take photo.
    takePhoto() {
      this.dialog = true;
      const canvas = this.$refs.canvas;
      canvas
        .getContext("2d")
        .drawImage(this.videoElement, 0, 0, this.width, this.height);
      this.capture = canvas.toDataURL("image/png");
    },
    setCaptures() {
      if(this.log_edit){
    
      this.ADD_TO_EVIDENCES({
        img: this.capture,
        locationModel: { lat: Number(this.lat), lng: Number(this.lng) },
        date: new Date(),
      });

  
      // If there is stream, stop it.
      if (this.currentStream) {
        this.stopStream();
      }

      this.$router.push("/detail-log");

      }else{
      this.SET_LOGBOOK_CAPTURE_COUNT(this.captureCount + 1);
      this.ADD_TO_EVIDENCES({
        img: this.capture,
        locationModel: { lat: Number(this.lat), lng: Number(this.lng) },
        date: new Date(),
      });
      // If there is stream, stop it.
      if (this.currentStream) {
        this.stopStream();
      }

      this.$router.push("/territory/addLogbook");
      }

    },
    goBack() {
      if(this.log_edit){
      this.$router.push("/detail-log");
      }else{
      this.$router.push("/territory/addLogbook");
      }

    },
  },
};
</script>

<style scoped>
.btn_float {
  position: absolute;
  bottom: 100px;
  left: 43%;
}
</style>
